import React, { useState, useEffect } from 'react';
import LcAccordion from '../../../../../components/Generic/LcAccordion';
import { PPFormHH, PPFormTemplate } from '../../../../../components/Layout/PPFormHH/PPFormHH';
import ServiceService from '../../../../../services/ServiceService/ServiceService';
import { SolicitationView } from '../../../../../models/SolicitationView';
import LcLoading from '../../../../../components/Generic/LcLoading';
import SolicitationService from "../../../../../services/SolicitationService/SolicitationService";
import "./index.css";

interface Props {
    item: any,
}

const SolicitationDetailsDynamicForm: React.FC<Props> = (props) => {
    const item: SolicitationView = props.item;
    const [title, setTitle] = useState<string>("Form Dinâmico");
    const [templatePPForm, setTemplatePPForm] = useState<PPFormTemplate>();
    const serviceService = new ServiceService(props);
    const [loading, setLoading] = useState<boolean>(false);
    const [resultDataResult, setResultDataResult] = useState<any>();
    const [resultDataResultTeste, setResultDataResultTeste] = useState<any>();
    const [refreshSeed, setRefreshSeed] = useState<number>();
    const [error, setError] = useState<any>();
    const [show, setShow] = useState<boolean>(false);
    const solicitationService = new SolicitationService(props);

    useEffect(() => {
        setTemplatePPForm(undefined);
        setTitle("");
        setShow(false);
        setResultDataResult([]);
        setResultDataResultTeste([]);
        setLoading(false);

        if (item) {
            buildExtraForm();
        }
    }, [item])

    async function buildExtraForm() {
        setLoading(true);
        const itemTemp = item;

        try {
            var response = await serviceService.getForm(item.idProcess, false, true, item.idService, item.id);
            var solicitationResponse = await solicitationService.GetDynamicFormData(item.id);

            if (itemTemp === item) {
                setResultDataResultTeste(solicitationResponse.data);
                setResultDataResult(solicitationResponse.data);
                if (response.data !== '') setShow(true);

                setTemplatePPForm(response.data);
            }
        } catch (e) {

        }

        setLoading(false);
    }

    const handleResultData = (data: any) => {
        setResultDataResult(resultDataResultTeste);
    }

    return (
        <div className={'divOrderDynamicForm'}>
            <LcLoading loading={loading} label={"Carregando..."}>
                {
                    show && templatePPForm &&
                     <LcAccordion title={templatePPForm && templatePPForm.title ? templatePPForm.title : ''} visible={true} iconNormal={true}>
                            <PPFormHH
                                header={''}
                                EditForm={false}
                                data={resultDataResult}
                                template={templatePPForm}
                                detailButton={false}
                                visible={false}
                                enableNotifications={true}
                                refreshSeed={refreshSeed}
                                setResultData={(data) => handleResultData(data)}
                                setError={(error) => { setError(error); }}
                                disableFields={true}
                                maxWidth={"28rem"}
                                maxWidthInternal={"27rem"}
                                direction={"column"}
                            />
                        </LcAccordion>
                }
            </LcLoading>
        </div>
    );
};

export default SolicitationDetailsDynamicForm;